import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Box from "@mui/material/Box";

import ExcelDownloadCard from "../Component/Excel/ExcelDownloadCard";
import WorksComponent from "../Component/Works/WorksComponent";
import { tokenAtom } from "../states/Atoms/AuthAtoms";
import { Button, Typography } from "@mui/material";

const WorksPage = () => {
  const history = useHistory();
  const token = useRecoilValue(tokenAtom);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (token) {
      if (token.id !== "master") {
        history.push("/");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token.id]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "30px",
        height: "100%",
        px: 10,
        py: 6,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 1.5,
          py: 2,
          px: 10,
          border: "1px solid #f0ad4e",
          borderRadius: "8px",
          background: "linear-gradient(145deg, #fffbe6, #fff3cd)",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#d9534f",
              mb: 0.5,
            }}
          >
            ⚠ 동시 실행 주의 안내
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#856404",
              lineHeight: 1.5,
            }}
          >
            본 기능은{" "}
            <span style={{ color: "#d9534f" }}>
              여러 사용자가 동시에 실행할 경우 <b>서버가 중단</b>
            </span>
            될 수 있습니다.
            <br />
            서버 중단 시 <b>개발팀에 즉시</b> 알려야 복구가 가능하며, 복구까지
            일정 시간이 소요될 수 있습니다.
            <br />
            <Typography sx={{ color: "#d9534f" }}>
              반드시 <b>순서대로</b> 실행해 주시기 바랍니다.
            </Typography>
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
          width: "calc(100% - 40px)",
          maxWidth: "650px",
          border: "2px solid #efefef",
          borderRadius: "5px",
          boxShadow:
            "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        }}
      >
        <Typography component="h2" sx={{ fontSize: "20px" }}>
          인보이스별 수입차량 조회

          <iframe
            id="getImpVehicleByInvs"
            src="https://extra-util.aonecustoms.com/GetImpVehicleByInvs"
            style={{ width: "100%", height: "650px", border: "none" }}
            title="Get Import Vehicles By Invoice"
            onLoad={() => {
              const iframe = document.getElementById(
                "getImpVehicleByInvs"
              );
              iframe?.contentWindow?.postMessage(
                { type: "TOKEN", token: localStorage.getItem("token") },
                "https://extra-util.aonecustoms.com/"
              );
            }}
          />
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
          width: "calc(100% - 40px)",
          maxWidth: "650px",
          border: "2px solid #efefef",
          borderRadius: "5px",
          boxShadow:
            "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        }}
      >
        <Typography component="h2" sx={{ fontSize: "20px" }}>
          차량 삭제

          <iframe
            id="차량 삭제"
            src="https://extra-util.aonecustoms.com/delete-car"
            style={{ width: "100%", height: "650px", border: "none" }}
            title="Extra Util"
            onLoad={() => {
              const iframe = document.getElementById(
                "차량 삭제"
              )
              iframe?.contentWindow?.postMessage(
                { type: "TOKEN", token: localStorage.getItem("token") },
                "https://extra-util.aonecustoms.com/"
              );
            }}
          />
        </Typography>


      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
          width: "calc(100% - 40px)",
          maxWidth: "650px",
          border: "2px solid #efefef",
          borderRadius: "5px",
          boxShadow:
            "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>인보이스별 수입차량 조회</Typography>
        <Button
          variant="outlined"
          sx={{ mt: 2, alignSelf: "flex-end" }}
          onClick={() => setOpenModal(true)}
        >
          보기
        </Button>

        {/* Modal */}
       
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              bgcolor: "rgba(0,0,0,0.5)",
              zIndex: 2000,
              display: openModal ? '' : 'none', // displaynone as per instruction
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100vw",
                height: "100vh",
                height: "90vh",
                bgcolor: "#fff",
                borderRadius: 2,
                boxShadow: 24,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                sx={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  zIndex: 10,
                  minWidth: 0,
                  width: 40,
                  height: 40,
                  borderRadius: "8px",
                  fontWeight: "bold",
                  p: 0
                }}
                onClick={() => setOpenModal(false)}
              >
                 닫기
              </Button>
              <iframe
                id="getImpVehicleByInvs"
                src="https://extra-util.aonecustoms.com/?dropdown=ImpVehicleInvA"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  flexGrow: 1,
                  marginTop: 0,
                }}
                title="Get Import Vehicles By Invoice"
                onLoad={() => {
                  const iframe = document.getElementById("getImpVehicleByInvs");
                  iframe?.contentWindow?.postMessage(
                    { type: "TOKEN", token: localStorage.getItem("token") },
                    "https://extra-util.aonecustoms.com/"
                  );
                }}
              />
            </Box>
          </Box>
        
      </Box>

        <WorksComponent />
        <ExcelDownloadCard
          title="TCMS 인보이스 FTA 적용 데이터 다운로드"
          url="/excel/fta/apply"
          filename="FTA적용현황"
        />
        <ExcelDownloadCard
          title="RDC 단가차이 내역 다운로드"
          url="/excel/rdc/subtract"
          filename="RDC_Subtract"
        />
        <ExcelDownloadCard
          title="TCMS New 자재 리스트 다운로드"
          url="/excel/tcms/new"
          filename="TCMS_New"
        />
        <ExcelDownloadCard
          title="TCMS FTA 적용 현황 품목 다운로드"
          url="/excel/fta/apply/item"
          filename="FTA적용현황_품목"
        />
      </Box>
      );
};

      export default WorksPage;
